import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import QuickView, { useQuickView } from 'components/quickView';
import { breakpoint, sizes } from 'variables';
import TerminatePendingQuickView from './components/TerminatePendingQuickView/TerminatePendingQuickView';

const StyledQuickView = styled(QuickView)`
    // && for specificity
    && {
        ${breakpoint.up(sizes.md)} {
            width: 520px;
        }
    }
`;

export default function TerminatePending() {
    const [searchParams] = useSearchParams();
    const actionParam = searchParams.get('action');
    const { toggle } = useQuickView('TerminatePlusPendingSubscription');

    // Used to open modal/draw via URL (primarily used for deep linking from emails)
    useEffect(() => {
        if (actionParam === 'cancelPlusPendingSubscription') {
            toggle(true);
        }
    }, []);

    if (!actionParam) return null;

    return (
        <StyledQuickView quickViewId="TerminatePlusPendingSubscription">
            <TerminatePendingQuickView onClose={() => toggle(false)} />
        </StyledQuickView>
    );
}
